import { m as motion, useReducedMotion } from "framer-motion";
import { Quote, Star, Users, Zap } from "lucide-react";

const values = [
  {
    key: "honesty",
    word: "Rakt",
    body: "Vi säger nej om vi tror att vi inte är rätt — och varför. Inga säljiga floskler.",
    icon: Quote,
    accent: "text-mint",
    bg: "from-mint/10",
  },
  {
    key: "craft",
    word: "Hantverk",
    body: "Premium ska kännas i varje frame. Vi släpper inte ifrån oss något vi inte själva skulle dela.",
    icon: Star,
    accent: "text-butter",
    bg: "from-butter/10",
  },
  {
    key: "human",
    word: "Människonära",
    body: "Vi gör film för människor — inte för algoritmen, inte för pitchdecket.",
    icon: Users,
    accent: "text-peach",
    bg: "from-peach/10",
  },
  {
    key: "tempo",
    word: "Tempo",
    body: "En film som kommer för sent har redan tappat halva sitt värde. Vi håller takten.",
    icon: Zap,
    accent: "text-mint",
    bg: "from-mint/10",
  },
];

/** Four-value grid for Om Fenny — large typographic blocks with hover-lift. */
export function ValuesGrid() {
  const reduce = useReducedMotion();
  return (
    <section className="py-24 md:py-32">
      <div className="container-wide">
        <div className="mb-16 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.22em] text-mint">Värderingar</div>
          <h2 className="mt-4 text-balance text-4xl font-semibold leading-tight md:text-6xl">
            Fyra ord vi mäter oss mot.
          </h2>
        </div>
        <div className="grid gap-4 md:grid-cols-2 lg:gap-6">
          {values.map((v, i) => (
            <motion.div
              key={v.key}
              initial={reduce ? false : { opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className={`group relative overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-br ${v.bg} to-transparent p-8 transition-transform hover:-translate-y-1 md:p-12`}
            >
              <v.icon className={`h-7 w-7 ${v.accent}`} />
              <div
                className={`mt-8 font-bold leading-[0.95] tracking-[-0.04em] ${v.accent}`}
                style={{ fontSize: "clamp(2.5rem, 6vw, 5rem)" }}
              >
                {v.word}.
              </div>
              <p className="mt-4 max-w-md text-pretty text-base leading-relaxed text-muted-foreground md:text-lg">
                {v.body}
              </p>
              <div
                aria-hidden
                className="pointer-events-none absolute -right-10 -bottom-10 h-40 w-40 rounded-full bg-white/[0.03] blur-2xl transition-opacity group-hover:bg-white/10"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
